module.exports = __webpack_public_path__ + "static/20-11-17c4b5a3f3dc454b309ca0162786dba3.jpg";